export const CaptionIcon = () => (
  <div className="h-[1em] flex items-center">
    <span className="block align-middle leading-[8px] text-[10px] font-mono font-semibold">
      ALT
    </span>
  </div>
)
